//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import WysiwygIcon from '@mui/icons-material/Wysiwyg'
import { Button, Typography } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import { PoolBaseOverviewCTO, PoolOverviewCTO, PoolOverviewCTOSchema } from '@shared/sharedTypes'
import * as React from 'react'
import { ReactElement } from 'react'
import { Link } from 'react-router-dom'

import { PoolTypeEnum, RoleEnum } from '@shared/Enums'
import { useOtChainState, useOtSelector } from '@react/redux/store'

import { logOT } from '@shared/loggingShared'
import TableColumn from '@react/components/elements/TableColumn'

const defaultColumns: readonly TableColumn[] = [
  new TableColumn(PoolOverviewCTOSchema.describe().fields.name),
  new TableColumn(PoolOverviewCTOSchema.describe().fields.state),
  // new TableColumn(PoolOverviewCTOSchema.describe().fields.totalAssets),
  // new TableColumn(PoolOverviewCTOSchema.describe().fields.pptShares),

  new TableColumn(PoolOverviewCTOSchema.describe().fields.totalAvailableAssets),
  new TableColumn(PoolOverviewCTOSchema.describe().fields.totalAvailableSupply),
]

function LiquidityPoolRow(props: { poolOverviewCTO: PoolOverviewCTO; columns: readonly TableColumn[] }): ReactElement {
  const { poolOverviewCTO } = props
  const columns = props.columns

  const poolAddr = poolOverviewCTO.poolAddr

  if (poolOverviewCTO) {
    return (
      <React.Fragment>
        <TableRow hover role="checkbox" tabIndex={-1} key={poolAddr}>
          <TableCell>
            <IconButton component={Link} to={`/pools/${poolAddr ?? ''}`} aria-label="expand row" size="small">
              <WysiwygIcon fontSize={'large'} />
            </IconButton>
          </TableCell>
          {columns.map((column) => {
            return column.getTableCell(poolOverviewCTO)
          })}
          <TableCell>
            {/* <IconButton */}
            {/*  aria-label="Edit" */}
            {/*  size="small" */}
            {/*  onClick={() => setOpenPoolEditModal(true)} */}
            {/* > */}
            {/*  <ModeEditIcon/> */}
            {/* </IconButton> */}
          </TableCell>
        </TableRow>
        {/* <TableRow> */}
        {/*  <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}> */}
        {/*  <LiquidityPoolBar liquidityPool={liquidityPool} ></LiquidityPoolBar> */}
        {/*  </TableCell> */}
        {/* </TableRow> */}
      </React.Fragment>
    )
  } else {
    return <></>
  }
}

export default function PoolList(props: { columns?: readonly TableColumn[] }): ReactElement {
  const columns = props.columns ?? defaultColumns
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)

  const {
    userConnection: { roleEnum },
  } = useOtChainState()
  const poolOverviewCTOs = useOtSelector((state) => Object.values(state.poolState.poolOverviewCTOs))

  const handleChangePage = (_event: unknown, newPage: number): void => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  logOT.debug('Pools', poolOverviewCTOs)

  

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 800 }}>
        <div>
          <Typography variant="bodyBold" gutterBottom component="div">
            Loan Vault
          </Typography>
          {roleEnum === RoleEnum.POOL_ADMIN ? (
            <Button
              sx={{
                float: 'left',
                backgroundColor: '#171717',
                color: '#FFFFFF',
              }}
              variant="contained"
              component={Link}
              to={'/pools/add/'}
            >
              Add LiquidityPool
            </Button>
          ) : (
            <></>
          )}
        </div>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell key="expander" style={{ minWidth: 20 }}></TableCell>
              {columns.map((column) => (
                <TableCell key={column.propName} align={column.align} style={{ minWidth: column.minWidth }}>
                  {column.schema.label ?? ''}
                </TableCell>
              ))}
              <TableCell key="actions" style={{ minWidth: 20 }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {poolOverviewCTOs
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row: PoolBaseOverviewCTO) => {
                if (row.poolType === PoolTypeEnum.Term) {
                  return (
                    <LiquidityPoolRow key={row.poolAddr} columns={columns} poolOverviewCTO={row as PoolOverviewCTO} />
                  )
                } else {
                  return <Typography key={row.poolAddr}>Not implemented2 TODO V5</Typography>
                }
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={poolOverviewCTOs?.length ?? 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  )
}
